import { styled } from '@atom-web/core'
import { Box } from '@atom-web/micros'

const Ribbon = styled('div', {
	height: '26px',
	width: '100%',
	paddingLeft: '16px',
	paddingRight: '16px',
	borderTopLeftRadius: '$2',
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',

	fontWeight: '$extrabold',
})

function Ribbonexample({
	text,
	backgroundColor = 'rgb(255, 201, 51)',
	icon,
	textColor = '$black',
	fontSize = '$2',
}) {
	return (
		<Ribbon
			css={{
				backgroundColor: backgroundColor,
				color: textColor,
				fontSize: fontSize,
			}}
		>
			<Box
				css={{
					position: 'absolute',
					width: '16px',
					height: '80%',
					backgroundColor: backgroundColor,
					transform: 'skewY(45deg)',
					left: 0,
					bottom: '-9px',
				}}
			></Box>
			<Box
				css={{
					position: 'absolute',
					width: '16px',
					height: '80%',
					transform: 'skewX(315deg)',
					right: '-6px',
					top: 0,
					backgroundColor: backgroundColor,
				}}
			></Box>
			<Box
				css={{
					position: 'absolute',
					width: '16px',
					height: '80%',
					transform: 'skewX(45deg)',
					right: '-6px',
					bottom: 0,
					backgroundColor: backgroundColor,
				}}
			></Box>
			{icon ? icon : null}
			{text ? text : 'Recommended'}
		</Ribbon>
	)
}
export default Ribbonexample
